import styled from 'styled-components';
import { flexbox, justifyContent, alignItems } from '../../../../styles/helpers/flexbox';

const ConfirmationContainer = styled.div(() => `
    ${flexbox()}
    ${justifyContent('center')}
    ${alignItems('center')}
 
    position: relative;
    width: 80px;
    height: 36px;
`);

const CancelIconContainer = styled.div(() => `
    ${flexbox()}
 
    height: 100%;
    cursor: pointer;
    margin-right: 5px;
    border: 1px solid #FCB290;
    border-radius: 20%;

    &:hover {
        background-color: #FCB290;
        
    }
`);

const OkIconContainer = styled(CancelIconContainer)(() => `
    border: 1px solid #9BE49D;

    &:hover {
        background-color: #9BE49D;
    }
`);


export {
    ConfirmationContainer,
    CancelIconContainer,
    OkIconContainer
};



// WEBPACK FOOTER //
// ./app/containers/default-courses/components/archive-course/styled.js